import { useSharedContext } from "./shared-context";
import { fhirSections } from "../shared-components/fhir-sections/sections";

export const useFhirSections = () => {
  useSharedContext();

  return { filteredFhirSections: fhirSections };
};
